import React from 'react';


function SettingsPage() {
    return (
        <div>
            <h2>Page under construction --- our ingeneous engineers are working on it</h2>
            <img title="Our oompa loompa is processing. Please wait." src={'./processing.gif'} alt="loading..." align="middle" />
            </div>
    );
}

export default SettingsPage;